const { Fields } = require("./fields");

const companyFieldLabels = {
    "default": {
        cardLabel: Fields.CARD_LABEL,
        maestroLabel: Fields.MAESTRO_LABEL
    },
    "to": {
        cardLabel: Fields.CARD_MOBILE_LABEL,
        maestroLabel: Fields.CASH_LABEL
    }
};

/**
 * Get a company-specific field label.
 */
function getCompanyFieldLabel(companyCode, fieldType) {
    const companyLabels = companyFieldLabels[companyCode] || {};
    const defaultLabels = companyFieldLabels['default'] || {};
    return companyLabels[fieldType] || defaultLabels[fieldType] || [];
}

module.exports = {
    getCompanyFieldLabel,
};